export default function tableOfContentsToggle() {
  if (typeof window !== "undefined" && window.document) {
    const header = window.document.querySelector(".Toc-header")
    const tocInner = window.document.querySelector(".Blog-sidebar-toc-inner")
    const toc = window.document.querySelector(".Blog-sidebar-toc")
    // Allow toc display/hide on mobile
    header.addEventListener("click", e => {
      const vWidth =
        window.innerWidth || window.document.documentElement.clientWidth // viewport
      if (vWidth < 841) {
        e.preventDefault()
        if (toc.classList.contains("active")) {
          tocInner.setAttribute("style", "display: none")
          toc.classList.remove("active")
        } else {
          tocInner.setAttribute("style", "display: block")
          toc.classList.add("active")
        }
      }
    })

    // Always display toc on non-mobile devices
    // Always hide toc on mobile (initially)
    window.addEventListener("resize", () => {
      const vWidth =
        window.innerWidth || window.document.documentElement.clientWidth // viewport
      if (vWidth < 841) {
        if (toc.classList.contains("active")) {
          tocInner.setAttribute("style", "display: none")
          toc.classList.remove("active")
        }
      } else {
        if (!toc.classList.contains("active")) {
          tocInner.setAttribute("style", "display: block")
          toc.classList.add("active")
        }
      }
    })
  }
}
